__turbopack_context__.v({
  "hasSubmitted": "yGOxyW_hasSubmitted",
  "inputWrapper": "yGOxyW_inputWrapper",
  "root": "yGOxyW_root",
  "submittedMessage": "yGOxyW_submittedMessage",
});
